import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Tabs = ({ children, className, expand, ...rest }) => {
  const classes = cn('c-tabs', className, {
    'c-tabs--expand': expand,
  });
  return (
    <ul className={classes} role="tablist" {...rest}>
      {children}
    </ul>
  );
};

export default Tabs;

Tabs.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  expand: PropTypes.bool,
};

Tabs.defaultProps = {
  children: null,
  className: '',
  expand: false,
};
